import React from 'react';
import { compose } from '@/utils/story-composer';
import LinkComponent from '@/components/elements/link-component';
import IconText from '@/components/elements/icon-text';

function FooterItem({ elementProps, name, link, icon }) {
	return (
		<li className="my-3 ml-4 md:ml-0" {...elementProps}>
			<LinkComponent text={name} link={link} appearance="w-4 h-4">
				<IconText text={name} icon={icon} />
			</LinkComponent>
		</li>
	);
}

export default FooterItem;

compose('footer-item', FooterItem);
